import { LookupItem, Property, reportWildcards } from '@cumu/shared';
import { controller, target } from '@github/catalyst';

@controller('report-choice-parameter')
class ReportChoiceParameterElement extends HTMLElement {
  @target declare propertySelect: HTMLDetailsElement;

  get property() {
    const input =
      this.propertySelect.querySelector<HTMLInputElement>('summary input');
    const value = input?.value;
    if (!value) {
      return null;
    }
    return JSON.parse(input.getAttribute('data-property')!) as Property;
  }

  handlePropertyChange() {
    const property = this.property;
    if (!property) {
      return;
    }
    const autocomplete = this.querySelector('auto-complete');
    if (!autocomplete) {
      throw new Error('Expected choice parameter autocomplete element.');
    }
    const src = new URL(autocomplete.getAttribute('src')!, location.href);
    if (
      src.searchParams.get('property_id') === property.property_id.toString()
    ) {
      return;
    }
    src.searchParams.set('property_id', property.property_id.toString());
    autocomplete.setAttribute('src', `${src.pathname}?${src.searchParams}`);
    const listBox = this.querySelector('autocomplete-list-box') as
      (HTMLElement & { clear?: () => void }) | null;
    const valueInput = listBox?.querySelector<HTMLInputElement>(
      '[data-target="autocomplete-list-box.valueInput"]'
    );
    let value: LookupItem[] | null = null;
    try {
      value = valueInput?.value ? JSON.parse(valueInput.value) : null;
    } catch {
      value = null;
    }
    const onlyPropertyIndependentWildcard =
      value?.length === 1 &&
      (value[0].id === reportWildcards.allChoices.id ||
        value[0].id === reportWildcards.unansweredChoice.id);
    if (!onlyPropertyIndependentWildcard) {
      listBox?.clear?.();
    }
  }
}

declare global {
  interface Window {
    ReportChoiceParameterElement: typeof ReportChoiceParameterElement;
  }
  interface HTMLElementTagNameMap {
    'report-choice-parameter': ReportChoiceParameterElement;
  }
}
